export const MODIFICAR_USER = 'MODIFICAR_USER'
export const LOADING = 'LOADING'
export const LANGUAGE = 'LANGUAGE'

